import React from 'react';
import styled from '@emotion/styled';
const _ = {
    forEach:    require('lodash/forEach'),
};

import AutoSizeTextArea from './AutoSizeTextArea';

let ExSpan = styled.span`
    display: inline-block;
    textarea {
        width: 100%;
    }
`;

export default class ExpandableSpan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: props.expanded,
            expandedText: props.expandedText,
        };
    }
    
    toggleExpanded=(e)=>{
        e.stopPropagation();
        this.setState({expanded: !this.state.expanded});
    }
    
    onChange=(e)=>{
        this.setState({expandedText: e.target.value},()=>{
            this.props.onEdit(e);
        });
    }
    
    render() {
        let childContent = this.state.expanded ? this.state.expandedText : this.props.collapsedText;
        let wrapStyle = {};
        if (this.props.activeForEditing) {
            childContent = (
                <AutoSizeTextArea value={this.state.expandedText} onChange={this.onChange}/>
            );
            wrapStyle.width = '100%';
        }
        else if (this.state.expanded  && this.props.generateComplexContent) {
            childContent = this.props.generateComplexContent();
        }
        
        return (
            <ExSpan className="expandable-span" style={wrapStyle} onClick={this.toggleExpanded} title={this.state.expanded ? "click to collapse" : "click to expand"}>
                { childContent }
            </ExSpan>
        )
    }
}
